import React from "react";
import BranchesPage from "./BranchesPage";
import useBranches from "./useBranches";

function Branches() {
  return <BranchesPage {...useBranches()} />;
}

export default Branches;
